export const REVALIDATIONS_QUERY_STALE_MS = 1000 * 60 * 3
